import Vue from "vue";

import axios from "axios";

import ModalError from "@Modals/Error.vue";

import confirmPassword from "@Helpers/confirmPassword";
import { logError, logWarning } from "@Helpers/logger";

function notify(text) {
  Vue.notify({
    type: "error",
    title: "Invalid",
    text,
    duration: 3000,
  });
}

/**
 * Set defaults on each incoming requests.
 */
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-Fingerprint": localStorage.getItem("sessionPrint"),
};

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.response?.config ?? error.config;
    const headers = error.response?.headers;
    const status = error.response?.status ?? null;

    // catch non-json response
    if (headers && headers["content-type"] !== "application/json") {
      Bus.$emit("showModal", ModalError, {
        title: __("Invalid"),
        message: __("something_went_wrong"),
        type: "error",
      });
    }

    // stop default interceptor right away when defined
    if (config.DISABLE_ERROR_INTERCEPTORS) {
      return Promise.reject(error);
    }

    // when response status starts with 5XX (when internal issue happens)
    if (/^5[0-9].*$/.test(status)) {
      notify(__("something_went_wrong"));
    }

    // display notifications base on response status
    switch (status) {
      case 401:
        localStorage.setItem("stateStatus", false);
        window.location.reload();
        notify(__("session_expired"));
        logError("The session has expired.");
        break;

      case 402:
        notify(__("payment_required"));
        logError("The payment method is required.");
        break;

      case 403:
        notify(__("permission_denied"));
        logError("Permission denied.");
        break;

      case 404:
        notify(__("not_found"));
        logError("The requested resource was not found.");
        break;

      case 419:
        notify(__("security_check_fails"));
        logError("The security check fails.");
        break;

      case 422:
        notify(__("validation_fails"));
        logError("The validations fails.");
        break;

      case 423:
        return confirmPassword()
          .then((_) => {
            return axios.request(error.config);
          })
          .catch((_) => {
            return Promise.reject(error);
          });

      case 431:
        logError("The request header fields too large.");
        notify(__("something_went_wrong"));
        break;
    }

    logWarning(error);

    return Promise.reject(error);
  },
);

export default axios;
